import { cn } from "@/lib/utils";
import { Skeleton } from "@components/ui/skeleton";

/**
 * Placeholder shown while mention cards load. The min-height is a guesstimate
 * of the smallest a real card can be, to keep the list from jumping.
 */
export function SkeletonMentionCard({ className }: { className?: string }) {
  return <Skeleton className={cn("min-h-62.5 w-full rounded-xl", className)} />;
}
